/**
 * Maximum number of page items in pagination row. Even numbers change to the nearest smaller odd.
 * Minimal value 5. includes symbol "..."
 */
export const MAX_PAGE_LIMIT = 10;
